import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hr-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hr-overview.html',
  styleUrls: ['./hr-overview.css'],
})
export class HrOverviewComponent {}
